import { booleanAttribute, Directive, ElementRef, inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[pcImageError]',
  standalone: true
})
export class ImageErrorDirective implements OnInit, OnDestroy {
  @Input({ transform: booleanAttribute }) showDefaultFlag = false;

  private defaultFlag = 'assets/flags/default-flag.svg';
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private removeErrorListener: (() => void) | undefined;

  ngOnInit(): void {
    this.setupErrorListener();
  }

  ngOnDestroy(): void {
    if (this.removeErrorListener) {
      this.removeErrorListener();
    }
  }

  private setupErrorListener(): void {
    this.removeErrorListener = this.renderer.listen(this.el.nativeElement, 'error', () => this.onError());
  }

  private onError(): void {
    if (this.showDefaultFlag) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.defaultFlag);
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
